import React from 'react';
import {Button} from '~/components/Button';
import {DateRangePickerInput} from '~/components/Controls/DatePicker';
import {SelectInput} from '~/components/Controls/Select';
import {Progress} from '~/components/Progress';
import {useAbility} from '~/lib/ability';
import {
    lastDaysDateRange,
    lastMonthDateRange,
    todayDateRange,
    todayMonthDateRange,
    yesterdayDateRange
} from '~/lib/date';
import {Intent} from '~/lib/intent';
import {DashboardAbility} from '~/modules/Dashboard/ability';
import {Charts} from '~/modules/Dashboard/components/Charts';
import {PerformanceTable} from '~/modules/Dashboard/components/PerformanceTable';
import {granularities} from '~/modules/Dashboard/models/Performance';
import {useDashboardReducer} from '~/modules/Dashboard/reducer';
import {useDspConnectionTypesQuery} from '~/modules/Dictionary/queries';
import style from './index.module.scss';

export function PayersPerformanceView() {
    const ability = useAbility(DashboardAbility);
    useDspConnectionTypesQuery();
    const {
        state: {query, isDataPending, isFeaturePending, isDimensionsPending},
        fetchData, setGranularity, setDateRange
    } = useDashboardReducer();
    const sellerId = (ability.isSeller() || ability.isSelfServe()) ? ability.sellerId() : undefined;

    return <div className={style.performanceView}>
        <div className="layout-content-box">
            <div className={style.summaryFilter}>
                <SelectInput className={style.granularitySelect}
                    placeholder='Granularity'
                    value={query.granularity}
                    items={granularities}
                    onChange={setGranularity}
                    disabled={isDataPending || isDimensionsPending || isFeaturePending}
                />
                <DateRangePickerInput
                    dateRange={{startDate: query.from, endDate: query.to}}
                    disabled={isDataPending || isDimensionsPending || isFeaturePending}
                    onChange={setDateRange}
                    ranges={[
                        {label: 'Today', onChoose: () => todayDateRange()},
                        {label: 'Yesterday', onChoose: () => yesterdayDateRange()},
                        {label: 'Last 7 days', onChoose: () => lastDaysDateRange(7)},
                        {label: 'Last 30 days', onChoose: () => lastDaysDateRange(30)},
                        {label: 'Last 60 days', onChoose: () => lastDaysDateRange(60)},
                        {label: 'This month', onChoose: () => todayMonthDateRange()},
                        {label: 'Last month', onChoose: () => lastMonthDateRange()},
                        {label: 'Last 90 days', onChoose: () => lastDaysDateRange(90)},
                    ]}
                />
                <Button disabled={isDataPending} onClick={() => fetchData({sellerId})} leftIcon={<i className='fa fa-check'/>}
                    intent={Intent.PRIMARY}>Apply</Button>
            </div>
            {isDataPending ? <Progress/> : <>
                <Charts/>
                <PerformanceTable/>
            </>}
        </div>
    </div>;
}
